export interface IMainState {
  gameSwitcherHover: string;
}

export const InitialMainState: IMainState = {
  gameSwitcherHover: 'cs'
};
